import { put, select } from 'redux-saga/effects';
import {
  gridPanelTabChanged,
  lockedContentChanged,
  selectGridPanel,
  selectLockedContent,
} from 'features/layout/features/content/contentSlice';
import { ContentData, GridPanelName } from 'features/layout/features/content/types';
import { fileViewed, whiteboardViewed } from 'features/content-library/actions';
import { screenshareSelected } from 'features/screenshare/actions';
import { selectScreenshareStreams } from 'features/layout/features/order/orderSlice';
import { SourceDetails } from 'features/layout/types';
import { currentActiveFileUpdated } from 'features/content-library/contentLibrarySlice';
import { panelMap } from 'features/layout/features/content/constants';

export function* navigateToLockedContentSaga() {
  const lockedContent: ContentData | null = yield select(selectLockedContent);
  if (!lockedContent) {
    return;
  }

  const { type, id, page, url } = lockedContent;

  const currentPanel: GridPanelName = yield select(selectGridPanel);
  const targetPanel: GridPanelName = panelMap[type];

  if (targetPanel !== currentPanel) {
    yield put(gridPanelTabChanged(targetPanel));
  }

  if (type === 'screenshare') {
    const screenShares: (SourceDetails & { feedId: string })[] =
      yield select(selectScreenshareStreams);

    const screenShare = screenShares.find((item) => item.feedId === id);

    if (!screenShare) {
      yield put(lockedContentChanged(null));
      return;
    }

    yield put(
      screenshareSelected({
        feedId: screenShare.feedId,
        userId: screenShare.userId,
        update: true,
      })
    );

    return;
  }

  if (type === 'whiteboard') {
    yield put(whiteboardViewed(id));
    return;
  }

  if (type === 'file') {
    let data;

    if (page !== undefined || url) {
      data = { page, url };
    }

    yield put(fileViewed({ id, data }));
    yield put(currentActiveFileUpdated(id));
  }
}
